var portfolioDelete = {
	title: "Eliminazione del portafoglio virtuale",
	nameInputLabel: "Nome del Portafoglio",
	alertHeading: "Sei sicuro di voler eliminare il portafoglio virtuale?",
	alertBody: "Se sì, fare clic su Ok. Si prega di notare che i portafogli eliminati non possono essere ripristinati.",
	confirmBtn: "Ok",
	cancelBtn: "Annulla"
};
var it = {
	portfolioDelete: portfolioDelete
};

export { it as default, portfolioDelete };
